import { Component, OnInit, OnDestroy, Inject, HostListener, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { BaseService } from '../../shared-service/base.service';
import { NavbarService } from '../navbar/navbar.service';
import { LoginService } from './../../login/login.service';
import { WindowRef } from '../../shared-service/windowRef.service';
//import { window } from 'rxjs';
import { SearchCardData } from '../../shared-components/search-card/search-card.model';
import { EntityType } from '../../shared-service/EntityType';

declare var jquery: any;
declare var $: any;

@Component({
  selector: 'global-search',
  templateUrl: './global-search.component.html',
  styleUrls: ['./global-search.component.css']
})
export class GlobalSearchComponent implements OnInit, OnDestroy, AfterViewInit {

  constructor(public bs: BaseService, private loginService: LoginService, private route: ActivatedRoute, private router: Router, private navbarService: NavbarService,
    private location: Location, private winRef: WindowRef) {


  };
  public searchCardDataList: SearchCardData[] = [];
  private params: Object | any = {};
  public searchListData: Object | any = {};
  private scrollToBottom: Boolean = false;
  private maxPage: number = 0;
  private searchType: string = "";
  private searchText: string = "";
  private autocmpltsrchtext: string = "";
  private userId: number = 0;

  ngOnInit() {

    this.InitCarousel();
    this.navbarService.currentValueGlobalSearch.subscribe(
      (result: any) => {
        setTimeout(function () {
          $('#globalsearchsection .owl-item').removeAttr("style");
        }, 1000);
        if (result['EnableGlobalSearch']) {

          this.emptySearchList();
          this.removeStyle();
          this.searchText = result['GlobalSearchContent'];
          $("#searchInputControl").val(result['GlobalSearchContent']);
          this.winRef.nativeWindow.document.getElementById('LA').className += " active2";
          this.searchType = "L";
          this.params = this.navbarService.getSearchParams();
          this.params['SearchText'] = this.searchText.toLowerCase();
          this.params['EntityType'] = EntityType.MyLearning;
          this.params['SearchTypeList'] = [this.searchType];
          this.params['SearchType'] = this.searchType;
          //await this.getUserPrivilegeDetails();
          this.globalSearch();
        }
        $('#searchModal').focus();
      });
  }

  ngAfterViewInit() {
    this.RegisterAutoComplete();
  }
  RegisterAutoComplete() {
    let currentClass = this;
    $("#searchInputControl").autocomplete({
      source: function (request: any, response: any) {
        if (request.term != currentClass.autocmpltsrchtext) {
          currentClass.autocmpltsrchtext = request.term;
          currentClass.navbarService.getAutoCmplteData(function (data: any) {
            response($.map(data, function (obj: any, key: any) {
              if (obj.toUpperCase().indexOf(request.term.toUpperCase()) >= 0) {
                return {
                  label: obj, // Label for Display
                  value: obj // Value
                }
              } else {
                return null;
              }
            }));
          }, currentClass.autocmpltsrchtext, EntityType.MyLearning, currentClass.searchType);
        }
      },
      autoFocus: true,
      html: true,
      minLength: 2,
      delay: 1000,
      open: function (event: any, ui: any) { },
      close: function (event: any, ui: any) {
        currentClass.autocmpltsrchtext = "";
      },
      select: function (event: any, ui: any) {
        $(this).val(ui.item.label);
        currentClass.searchText = ui.item.label;
        currentClass.globalSearch();
        event.preventDefault();
      },
      scroll: true,
    });
  }

  showMore() {
    if (this.searchListData['TotalResults'] > this.params['PageSize']
      && this.params['PageNumber'] <= this.maxPage) {
      this.params['PageNumber'] = this.params['PageNumber'] + 1;
      this.scrollToBottom = true;
      this.globalSearch();
      // if (this.params['PageNumber'] >= this.maxPage)
      //   $('#globalShowMoreDiv').css("display", "none");
      // else
      //   $('#globalShowMoreDiv').css("display", "block");
    }
  }

  emptySearchList() {
    this.searchCardDataList = [];
    this.params['SearchTypeList'] = [this.searchType];
    this.params['PageNumber'] = 1;
    this.params['SearchType'] = this.searchType;
    this.searchListData['TotalResults'] = 0;
    $('#globalShowMoreDiv').css("display", "none");
  }
  globalSearchClick(refrenceFlag: boolean) {
    if ($('#searchInputControl').val().length > 2) {
      if (this.searchText != $("#searchInputControl").val() || this.params['SearchType'] != this.searchType) {
        this.emptySearchList();
        this.searchText = $("#searchInputControl").val().toLowerCase();
        this.globalSearch();
      }
      else {
        if ((this.searchType == 'B' && this.searchCardDataList.length == 0) || (this.searchType == 'L' && this.searchCardDataList.length == 0) || (this.searchType == 'D' && this.searchCardDataList.length == 0) || (this.searchType == 'S' && this.searchCardDataList.length == 0) || (this.searchType == 'V' && this.searchCardDataList.length == 0)) {
          this.globalSearch();
        }
      }
    }
  }


  globalSearch() {
    //this.getUserPrivilegeDetails()

    this.params['Skip'] = (this.params['PageNumber'] - 1) * (this.params['PageSize']);
    this.params['SearchText'] = this.searchText;

    $('#globalShowMoreDiv').css("display", "none");
    this.navbarService.getGlobalSearchDataFromServer(this.params, this.bs.config.storageSearchApiKey).then((data: any) => {
      $('#' + this.searchType + 'A').children().removeAttr("style");
      this.searchListData = data;
      this.maxPage = this.searchListData['TotalResults'] / this.params['PageSize'];
      if (this.scrollToBottom) {
        this.searchCardDataList = this.searchCardDataList.concat(data['Items']);
        this.scrollToBottom = false;
      } else {

        this.searchCardDataList = data['Items'];
      }

      if (this.searchListData['TotalResults'] > (this.params['PageSize'] * this.params['PageNumber']))
        $('#globalShowMoreDiv').css("display", "block");
      else
        $('#globalShowMoreDiv').css("display", "none");

    }, (data) => {

      this.bs.log('error', 'Error in getting list');
    });

  }

  InitCarousel() {
    setTimeout(function () {
      var owl = $('.owl-carousel-global-search');
      owl.owlCarousel({
        nav: true,
        loop: false,
        navRewind: false,
        margin: 0,
        dots: false,
        responsive: {
          0: {
            items: 1
          },
          480: {
            items: 3
          },
          1024: {
            items: 5
          },
          1160: {
            items: 6
          }
        }
      });


    }, 500);

  }

  openTab(evt: any, evntId: any) {
    var i, tablinks2;
    tablinks2 = this.winRef.nativeWindow.document.getElementsByClassName("tablinks2");
    for (i = 0; i < tablinks2.length; i++) {
      tablinks2[i].className = tablinks2[i].className.replace(" active2", "");
      // tablinks2[i].children[0].style.display = "none";
    }

    this.winRef.nativeWindow.document.getElementById(evntId + 'A').className += " active2";
    $('#' + evntId + 'A').children().removeAttr("style");
    this.searchType = evntId;
    this.emptySearchList();
    this.globalSearchClick(false);
  }

  removeStyle() {
    var i, tablinks2;
    tablinks2 = this.winRef.nativeWindow.document.getElementsByClassName("tablinks2");
    for (i = 0; i < tablinks2.length; i++) {
      tablinks2[i].className = tablinks2[i].className.replace(" active2", "");
    }
  }
  routeItem(searchCardEventData: any) {

    let itemId = searchCardEventData.Id;
    let itemType = searchCardEventData.ItemTypeCode;
    let itemModule = searchCardEventData.ItemModule;
    this.bs.isTrainingHistory = false;
    $('#searchModal').modal('hide');
    $('.sub-header').show();
    if (itemType == "C") {
      this.bs.activateMenuItem(itemModule);
      if (itemModule == "M") {
        this.bs.setCurrentModulePath(this.bs.loadModulePath('tsk_mdl'));
        this.routeTo(this.bs.loadModulePath('tsk_mdl') + this.bs.getDirectPath('crs_dtl'), { id: itemId, IsNodeClick: true });
      }
      if (itemModule == "A") {
        this.routeTo('/learner/taskList/container/catalog-detail', { id: itemId });
      }
      if (itemModule == "H") {
        this.bs.isTrainingHistory = true;
        this.bs.setCurrentModulePath(this.bs.loadModulePath('tsk_mdl'));
        this.routeTo(this.bs.loadModulePath('tsk_mdl') + this.bs.getDirectPath('crs_dtl'), { id: itemId, IsNodeClick: true });
      }

    }
    else if (itemType == "T") {
      this.bs.activateMenuItem(itemModule);
      if (itemModule == "M") {
        this.bs.setCurrentModulePath(this.bs.loadModulePath('tsk_mdl'));
        this.routeTo(this.bs.loadModulePath('tsk_mdl') + this.bs.getDirectPath('ilt_dtl'), { id: itemId });
      }
      if (itemModule == "A") {
        this.routeTo('/learner/taskList/container/catalog-ilt-detail', { id: itemId });
      }
      if (itemModule == "H") {
        this.bs.isTrainingHistory = true;
        this.bs.setCurrentModulePath(this.bs.loadModulePath('tsk_mdl'));
        this.routeTo(this.bs.loadModulePath('tsk_mdl') + this.bs.getDirectPath('ilt_dtl'), { id: itemId });
      }
    }
    else if (itemType == "V") {
      this.router.navigateByUrl("/learner/video-library/container/(home//videoPlayer:videoPlayer;videoid=" + itemId + ";channelId=null;date=" + new Date().getTime() + ")");
    }
    else if (itemType == "B") {
      let action = 'learner/briefcase/container';
      if (searchCardEventData.IsFile && searchCardEventData.ParentId > 0) {
        this.router.navigateByUrl('/learner/overview/container;date=' + new Date().getTime(), { skipLocationChange: true }).then(() => {
          this.router.navigate([action, { date: new Date().getTime(), id: searchCardEventData.ParentId, type: 4, IsShared: searchCardEventData.IsShared }]);
        });
      }
      else {
        if (searchCardEventData.IsFile) {
          this.router.navigateByUrl('/learner/overview/container;date=' + new Date().getTime(), { skipLocationChange: true }).then(() => {
            this.router.navigate([action, { date: new Date().getTime(), id: itemId, type: 1, IsShared: searchCardEventData.IsShared }]);
          });
        }
        else {
          this.router.navigateByUrl('/learner/overview/container;date=' + new Date().getTime(), { skipLocationChange: true }).then(() => {
            this.router.navigate([action, { date: new Date().getTime(), id: itemId, type: 4, IsShared: searchCardEventData.IsShared }]);
          });
        }

      }
    }
    else {
      this.bs.activateMenuItem(itemType);
      if (itemType == "D") {
        this.routeTo(this.bs.loadModulePath('cnvrstn_mdl'), { id: itemId });
      }
      else if (itemType == "S") {
        this.routeTo(this.bs.loadModulePath('srvy_mdl'), { id: itemId });
      }
    }
  }

  //Not in use
  routeVideoItem(itemId: string, itemType: string, itemModule: string, IsSubscribed: boolean, ChannelId: string) {
    this.bs.isTrainingHistory = false;
    $('#searchModal').modal('hide');
    if (itemType == "V") {
      this.bs.activateMenuItem(itemType);
      if (IsSubscribed) {
        this.routeTo(this.bs.loadModulePath('vd_mdl') + '/channelDetails', { id: ChannelId, videoId: itemId, isSubscribed: true }, { skipLocationChange: true });
      }
      else {
        this.routeTo(this.bs.loadModulePath('vd_mdl') + '/channelDetails', { id: ChannelId, videoId: itemId, isSubscribed: false }, { skipLocationChange: true });
      }
    }
  }

  getSearchItemCount() {
    let searchCount;
    searchCount = this.searchCardDataList.length;
    return searchCount;
  }

  ngOnDestroy() {
    $(".topnavbar-wrapper").attr("aria-hidden", "false");
    $(".sub-header").attr("aria-hidden", "false");
    $(".main-section").attr("aria-hidden", "false");
    $("footer").attr("aria-hidden", "false");
  }

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    console.log(event);
    this.closeSearchDetail();
  }

  closeSearchDetail() {
    $(".topnavbar-wrapper").attr("aria-hidden", "false");
    $(".sub-header").attr("aria-hidden", "false");
    $(".main-section").attr("aria-hidden", "false");
    $("footer").attr("aria-hidden", "false");
    this.navbarService.changeGlobalSearchValue({ "EnableGlobalSearch": false, "GlobalSearchContent": '' });
  }

  routeTo(path: string, params: object, skiploc = {}) {
    this.router.navigate([path, params]).then((res) => {
      console.log(res);
    });
  }

  // async getUserPrivilegeDetails() {
  //   if (this.bs.user['OSVisibilityClaim'] == null || this.bs.user['OSVisibilityClaim'] == undefined) {
  //     this.userId = this.bs.user['UserId'];
  //     await this.navbarService.getUserPrivilegeDetails(this.userId, "privilege").then(async (data: any) => {
  //       this.bs.user['OSVisibilityClaim'] = data.OSVisibilityClaim;
  //       this.bs.user['RoleVisibilityClaim'] = data.RoleVisibilityClaim;
  //       this.bs.user['JobRoleVisibilityClaim'] = data.JobRoleVisibilityClaim;
  //       this.bs.user['RAVisibilityClaim'] = data.RAVisibilityClaim;
  //       this.bs.user['UserSkills'] = data.UserSkills;
  //     });
  //   }

  // }

}
